import { ServiceBase } from '../../../../../core/services/ServiceBase'
import FinanceProxy from '../proxies/FinanceProxy'

class FinanceService extends ServiceBase {
  postOrganizationInfo(params) {
    return this.getData(() => FinanceProxy.postOrganizationInfo(params))
  }

  postTotalCompany(params) {
    return this.getData(() => FinanceProxy.postTotalCompany(params))
  }

  postHightLight(params) {
    return this.getData(() => FinanceProxy.postHightLight(params))
  }

  postLiquiditySolvencyAndCoverage(params) {
    return this.getData(() =>
      FinanceProxy.postLiquiditySolvencyAndCoverage(params),
    )
  }

  postAssetManagementEfficiency(params) {
    return this.getData(() =>
      FinanceProxy.postAssetManagementEfficiency(params),
    )
  }

  postProfitability(params) {
    return this.getData(() => FinanceProxy.postProfitability(params))
  }

  postBusinessGrowth(params) {
    return this.getData(() => FinanceProxy.postBusinessGrowth(params))
  }

  postCapitalAdequacy(params) {
    return this.getData(() => FinanceProxy.postCapitalAdequacy(params))
  }

  postAssetQuality(params) {
    return this.getData(() => FinanceProxy.postAssetQuality(params))
  }

  postEarningsQuality(params) {
    return this.getData(() => FinanceProxy.postEarningsQuality(params))
  }

  postFundingLiquidity(params) {
    return this.getData(() => FinanceProxy.postFundingLiquidity(params))
  }

  postBusinessPosition(params) {
    return this.getData(() => FinanceProxy.postBusinessPosition(params))
  }

  postCapitalEarningLeverage(params) {
    return this.getData(() => FinanceProxy.postCapitalEarningLeverage(params))
  }

  exportLiquiditySolvencyAndCoverage(params) {
    return this.getFileDownload(() =>
      FinanceProxy.exportLiquiditySolvencyAndCoverage(params),
    )
  }

  exportAssetManagementEfficiency(params) {
    return this.getFileDownload(() =>
      FinanceProxy.exportAssetManagementEfficiency(params),
    )
  }

  exportProfitability(params) {
    return this.getFileDownload(() => FinanceProxy.exportProfitability(params))
  }

  exportBusinessGrowth(params) {
    return this.getFileDownload(() => FinanceProxy.exportBusinessGrowth(params))
  }

  exportCapitalAdequacy(params) {
    return this.getFileDownload(() =>
      FinanceProxy.exportCapitalAdequacy(params),
    )
  }

  exportAssetQuality(params) {
    return this.getFileDownload(() => FinanceProxy.exportAssetQuality(params))
  }

  exportEarningsQuality(params) {
    return this.getFileDownload(() =>
      FinanceProxy.exportEarningsQuality(params),
    )
  }

  exportFundingLiquidity(params) {
    return this.getFileDownload(() =>
      FinanceProxy.exportFundingLiquidity(params),
    )
  }

  exportSecuritiesBusinessPosition(params) {
    return this.getFileDownload(() =>
      FinanceProxy.exportSecuritiesBusinessPosition(params),
    )
  }

  exportCapitalEarningLeverage(params) {
    return this.getFileDownload(() =>
      FinanceProxy.exportCapitalEarningLeverage(params),
    )
  }
}

export default new FinanceService()
